import React, {  useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { Menu, ShoppingCart,  X } from "lucide-react";
import Profile from "./components/Dropdown/Profile";
import BranchSelector from "./components/Dropdown/BranchSelector";
import { useAuth } from "./context/AuthContext";
import Logo from "./components/logo";
import Delire from "./components/Delire";
import { useTranslation } from "react-i18next";
import { FaInstagram, FaTiktok } from "react-icons/fa";
const Layout = () => {
  const { t } = useTranslation();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { cartTotal } = useAuth();
  const handleBranchChange = (branch) => {
  };
  
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  return (
    <div className="min-h-screen flex flex-col">
      {/* Top Navigation */}
      <nav className="sticky top-0 z-50 bg-white shadow-md print:hidden">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          {/* Burger Menu */}
        
          {/* Desktop Navigation Menu*/}
          <nav className="hidden md:flex space-x-6 px-2 justify-between w-[30%] text-green-900 font-extrabold">
            <Link to="/" className="hover:text-blue-600 text-center">
              {t('Home')}
            </Link>
            <Link
              to="/products/all"
              className="hover:text-blue-600 text-center"
            >
              {t('Products')}
            </Link>
            <Link to="/about" className="hover:text-blue-600 text-center">
              {t('About')}
            </Link>
          </nav>
          {/* Logo */}
          <Link to="/" className="mx-auto md:mx-1">
            <Logo />
          </Link>
          {/* tools Menu should be on the */}
          <div className=" px-4 py-3 space-x-3 flex justify-start items-center print:hidden">
            <div className="mx-3">
              <BranchSelector onBranchChange={handleBranchChange} />
            </div>
            <Link to="/cart" className="relative mx-3">
              <ShoppingCart size={24} />
              <span className="absolute -top-3 -right-3 bg-red-100 text-black text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {cartTotal}
              </span>
            </Link>
            <div className="mx-3">
              <Profile />
            </div>
          </div>
          <button onClick={toggleSidebar} className="md:hidden">
            <Menu size={24} />
          </button>
        </div>
      </nav>

      {/* Sidebar Mobile Menu */}
      <div
        className={`
       print:hidden fixed inset-y-0 left-0 z-60 w-64 bg-white shadow-xl 
        transform transition-transform duration-300 ease-in-out
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        md:hidden z-50
      `}
      >
        <div className="p-4 flex justify-between items-center border-b">
          <Delire />
          <button onClick={toggleSidebar}>
            <X size={24} />
          </button>
        </div>
        <nav className="flex flex-col p-4 space-y-4">
          <Link
            to="/"
            className="text-lg hover:text-blue-600"
            onClick={toggleSidebar}
          >
            {t('Home')}
          </Link>
          <Link
            to="/products/all"
            className="text-lg hover:text-blue-600"
            onClick={toggleSidebar}
          >
            {t('Products')}
          </Link>
          <Link
            to="/about"
            className="text-lg hover:text-blue-600"
            onClick={toggleSidebar}
          >
            {t('About')}
          </Link>
        </nav>
      </div>

      {/* Main Content Area */}
      <main className="flex-grow container mx-auto px-4 ">
        <Outlet />
      </main>

      {/* Footer */}
<footer className="bg-[#868653] text-white py-8">
  <div className="container mx-auto px-4 grid md:grid-cols-3 gap-6 text-center md:text-left">
    {/* Logo and Social Links */}
    <div>
      <h2 className="text-xl font-semibold mb-4">Delire Perfumes</h2>
      <div className="flex justify-center md:justify-start space-x-4">
          <a href="https://instagram.com/delire.qa" target="_blank" rel="noreferrer" className="text-white hover:text-pink-500 text-2xl">
            <FaInstagram />
          </a>
          <a href="https://tiktok.com/@delire.qa" target="_blank" rel="noreferrer" className="text-white hover:text-black text-2xl">
            <FaTiktok />
          </a>
      </div>
    </div>

    {/* Contact Info */}
    <div>
      <h3 className="text-lg font-semibold mb-2">Contact</h3>
      <p>Customer Service: <a href="tel:+97477759648" className="hover:underline">+974 7775 9648</a></p>
      <p>Support: <a href="tel:+97471700047" className="hover:underline">+974 7170 0047</a></p>
      <p><a href="mailto:info@delire.net" className="hover:underline">info@delire.net</a></p>
      <p><a href="https://delire.net" target="_blank" className="hover:underline">www.delire.net</a></p>
    </div>

    {/* Address */}
    <div>
      <h3 className="text-lg font-semibold mb-2">Address</h3>
      <p>Qatar, Doha</p>
      <p>Madinat Khalifa South</p>
      <p>Al-Jazeera Arabia St.</p>
      <p>Building No. 122, Second Floor</p>
    </div>
  </div>

  {/* Bottom line */}
  <div className="text-center mt-6 border-t border-white/30 pt-4 text-sm">
    © 2025 <span className="font-eightOne text-base">Delire</span> Perfumes. All Rights Reserved.
  </div>
</footer>

    </div>
  );
};

export default Layout;
